<template>
  <div class="mall-box">
    <div class="box">
      <p class="title">{{ $t("mall.title") }}</p>
      <!-- <p class="title-desc">提前捕捉优质项目发售信息，快人一步解锁投资机会</p> -->
      <div class="mall-list-box" v-loading="loading">
        <template v-for="(value, index) in mallList">
          <OldMallItem v-if="value.newGoodType === 1" :itemData="value" />
          <MallItem v-else :itemData="value" />
        </template>
        <MallNoData v-if="mallList.length <= 0" />
      </div>
      <el-pagination class="pagination-box" background layout="prev, pager, next" :total="malltotal"
        :page-size="pageData.pageSize" :current-page="pageData.pageNumber" @current-change="pageChange" />
    </div>

    <VFooter />
    <QuestionPopup />
  </div>
</template>

<script>
import { mapState } from "vuex";
import MallItem from "./components/MallItem";
import OldMallItem from "./components/OldMallItem";
import MallNoData from "./components/MallNoData";
import VFooter from "@/components/footer/VFooter";
import QuestionPopup from "@/components/QuestionPopup/index";
export default {
  components: {
    VFooter,
    MallItem,
    MallNoData,
    OldMallItem,
    QuestionPopup,
  },
  computed: {
    ...mapState(["user", "errorCode"]),
  },
  data() {
    return {
      currTab: "所有",
      currType: "全部",
      malltotal: 0,
      pageData: {
        pageNumber: 1,
        pageSize: 9,
      },
      oldPageData: {
        page: 1,
        rows: 10,
        // cateCode: "RWA|DIMD|TOP100|GCT",
        cateCode: "goods",
        queryDeep: 1,
      },
      loading: false,
      mallList: [],
    };
  },
  created() {
    this.getDataInfo();
  },
  methods: {
    getDataInfo() {
      this.loading = true;
      this.$axios.post("/mall/projects", this.pageData).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.mallList = res.data.data.rows || [];
          this.malltotal = res.data.data.total || 0;
        }
        this.$axios.post("/cms/getList", this.oldPageData).then((res) => {
          if (res.data.code === this.errorCode.ok) {
            if (res.data.data.rows && res.data.data.rows.length > 0) {
              const oldList =res.data.data.rows.map((item) => ({
                ...item,
                newGoodType: 1,
                summary: JSON.parse(item.summary),
              }));
              this.mallList = [...this.mallList, ...oldList];
            }
          }
          this.loading = false;
        });


      });
    },
    pageChange(pageNo) {
      this.pageData.pageNumber = pageNo;
      this.getDataInfo();
    },
    tabChange(val) {
      this.currTab = val;
    },
    typeChange(val) {
      this.currType = val;
    },
  },
};
</script>

<style lang="less" scoped>
.mall-box {
  position: relative;
  background: #f5f6f7;
  min-height: 100vh;

  .box {
    padding: 80px 120px;

    .pagination-box {
      text-align: center;
      margin-top: 40px;

      /deep/ .btn-prev,
      /deep/ .btn-next,
      /deep/ .number {
        width: 36px;
        height: 36px;
        line-height: 36px;
        background: #ffffff;
        box-shadow: 0px 2px 8px rgba(180, 180, 180, 0.06);
        border-radius: 6px;
      }

      /deep/ .active {
        background-color: #4063ff !important;
      }
    }

    .title {
      text-align: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 800;
      font-size: 32px;
      color: #333333;
      margin-bottom: 30px;
    }

    .title-desc {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #040404;
      text-align: center;
      margin-bottom: 32px;
    }

    .mall-list-box {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 24px;
      margin-top: 20px;
    }
  }
}
</style>
